import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Row, Switch, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetActivityLogShowNotificationsToggleTID = (parentTestId)=>getTestIds(parentTestId);
export const ActivityLogShowNotificationsToggle = (param)=>{
    let { value, onChange, testId } = param;
    const { ActivityLogShowNotificationsToggleTestIds } = useMemo(()=>GetActivityLogShowNotificationsToggleTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const labelId = ActivityLogShowNotificationsToggleTestIds.Label();
    return /*#__PURE__*/ _jsxs(Row, {
        testId: ActivityLogShowNotificationsToggleTestIds.Root(),
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: labelId,
                id: labelId,
                variant: "paragraph1",
                onClick: ()=>onChange(!value),
                children: t.activityLog.showSentNotifications()
            }),
            /*#__PURE__*/ _jsx(Switch, {
                bi: {
                    name: 'activity_log_show_sent_notifications'
                },
                testId: ActivityLogShowNotificationsToggleTestIds.Switch(),
                checked: value,
                onChange: (_event, next)=>onChange(next),
                inputProps: {
                    'aria-labelledby': labelId
                }
            })
        ]
    });
};
